/**
 * @desc 红人管理-合作启用
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(kolno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/enableCooperation/${kolno}`, {
      method: "POST",

      ...options,
    }),
  );
}
